import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const joinWaitlist = (email, source) =>
  axios.post(`${API}/waitlist`, { email, source }).then((r) => r.data);

export const startCheckout = (email) =>
  axios
    .post(`${API}/payments/checkout`, {
      lookup_key: "tilla_pro_monthly",
      origin_url: window.location.origin,
      email: email || null,
    })
    .then((r) => r.data);

export const getPaymentStatus = (sessionId) =>
  axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data);
